const mediaItems = [
  {
    title: '【漫画解说】这部国漫封神之作到底有多好看',
    desc: '深度解析今年现象级国漫作品，从剧情到画风全方位解读，带你看懂这部神作的魅力所在。',
    icon: 'ri-play-circle-line',
    duration: '15:28',
    views: '32.6万',
  },
  {
    title: '漫画家访谈：创作背后的故事与灵感来源',
    desc: '独家对话人气漫画家，揭秘创作日常、灵感来源和那些不为人知的幕后故事，漫画迷不容错过。',
    icon: 'ri-live-line',
    duration: '28:14',
    views: '18.9万',
  },
  {
    title: '画风大赏：2024年度最美漫画封面合集',
    desc: '精选今年最惊艳的漫画封面，从国风水墨到日系唯美，一场视觉盛宴带你领略漫画艺术的魅力。',
    icon: 'ri-gallery-line',
    duration: '12:06',
    views: '25.3万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩内容</h2>
          <p className="text-sm text-foreground-500">漫画解说、访谈与鉴赏，深度了解漫画世界</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-5 md:p-6 group cursor-pointer hover:scale-[1.02] transition-transform"
            >
              <div className="w-full h-44 rounded-xl bg-gradient-to-br from-background-200 to-background-300 flex items-center justify-center mb-4 relative overflow-hidden">
                <div className="w-16 h-16 rounded-full bg-background-50/80 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className={`${item.icon} text-primary-500 text-3xl`}></i>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-950/70 rounded text-xs text-background-50">
                  {item.duration}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2 line-clamp-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 mb-3">{item.desc}</p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}